import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { Device } from 'services/Device';
import { SolarTotalItem } from 'services/Totals';

interface CachedSolarItem {
  [key: number]: Array<{ total: SolarTotalItem; device: Device }>;
}

interface Props {
  cached?: CachedSolarItem;
  current?: number;
  dayTotal?: number;
  isVisible?: boolean;
  loading?: boolean;
  children: React.ReactNode;
}

export type UserTotalContextType = {
  cached: CachedSolarItem;
  setCached: Dispatch<SetStateAction<CachedSolarItem>>;
  current: number;
  setCurrent: Dispatch<SetStateAction<number>>;
  dayTotal: number;
  setDayTotal: Dispatch<SetStateAction<number>>;
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
};

const UserTotalContext = createContext<UserTotalContextType>({
  cached: {},
  setCached: () => console.warn('no userTotal provider'),
  current: 0,
  setCurrent: () => console.warn('no userTotal provider'),
  dayTotal: 0,
  setDayTotal: () => console.warn('no userTotal provider'),
  isVisible: false,
  setIsVisible: () => console.warn('no userTotal provider'),
  loading: false,
  setLoading: () => console.warn('no userTotal provider'),
});

export function useUserTotalContext(): UserTotalContextType {
  return useContext(UserTotalContext);
}

export function UserTotalProvider({ children }: Props): JSX.Element {
  const [cached, setCached] = useState<CachedSolarItem>({});
  const [current, setCurrent] = useState<number>(0);
  const [dayTotal, setDayTotal] = useState<number>(0);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <UserTotalContext.Provider
      value={{ cached, setCached, isVisible, setIsVisible, current, setCurrent, dayTotal, setDayTotal, loading, setLoading }}
    >
      {children}
    </UserTotalContext.Provider>
  );
}
